import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { ContactSection } from './ContactSection';
type EmergencyModalProps = {
  open: boolean;
  onClose: () => void;
};
export function EmergencyModal({
  open,
  onClose
}: EmergencyModalProps) {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-34" data-mp="2dq6kn7h18nrh">
      {open && <motion.div className="fixed inset-0 z-50 flex items-end bg-slate-950/35 p-3 md:items-center md:justify-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} onMouseDown={onClose} data-id="element-35" data-mp="2dr7xnhhlzkbu">
          <motion.section role="dialog" aria-modal="true" aria-labelledby="emergency-title" className="w-full max-w-md rounded-[28px] bg-white p-5 shadow-2xl" initial={{
        y: 28,
        opacity: 0.8
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 28,
        opacity: 0.8
      }} transition={{
        type: 'spring',
        stiffness: 360,
        damping: 30
      }} onMouseDown={event => event.stopPropagation()} data-id="element-36" data-mp="34plqs3gzk1r6">
            <div className="mb-5 flex items-start justify-between gap-4" data-id="element-37" data-mp="2uxfsyd41yq42">
              <div data-id="element-38" data-mp="2zrtr2na3nbcf">
                <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-emerald-700" data-id="element-39" data-mp="2zsd9e53nw1qz">
                  Термінова допомога
                </p>
                <h2 id="emergency-title" className="mt-1 text-[22px] font-bold tracking-[-0.04em] text-slate-950" data-id="element-40" data-mp="2796e5v59b2mf">
                  Оберіть спосіб зв’язку
                </h2>
              </div>
              <button type="button" onClick={onClose} className="rounded-full p-2 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-950 focus:outline-none focus:ring-2 focus:ring-emerald-600" aria-label="Закрити вікно контактів" data-id="element-41" data-mp="35jo8ytvhrgvz">
                <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-42" data-mp="2mn6e43lcj0vi" />
              </button>
            </div>
            <ContactSection heading="Ми вже на зв’язку" data-id="element-43" data-mp="30n7c9ba87u7a" />
          </motion.section>
        </motion.div>}
    </AnimatePresence>;
}